import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/omain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/omain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/omain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/omain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/omain/${Id}`);
  },
};
